import axiosInstance from './common/axiosInstance';

export interface PayGCCRequestPayload {
  gatwayname: string;
  servicename: string;
  product_name: string;
  description: string;
  quantity: number;
  unit_price: number;
  amount: number;
  sub_total: number;
  discount: number;
  vat: number;
  total: number;
}

export interface PayGCCResponseData {
  paymentno: string;
  payment_url: string;
  invoice_code: string;
  invoice_token: string;
}

export interface PayGCCResponse {
  message: string;
  data: PayGCCResponseData;
  success: boolean;
}

export interface OrderHistoryRequestPayload {
  page: number;
  per_page: number;
  gatwayname: string;
  servicename: string;
  product_name: string;
  from_date: string;
  to_date: string;
  searchkey: string;
  status: string;
}

export interface OrderHistoryItem {
  id: number;
  paymentno: string;
  gatwayname: string;
  status: string;
  servicename: string;
  product_name: string;
  description: string;
  quantity: number;
  unit_price: number;
  amount: number;
  sub_total: number;
  discount: number;
  vat: number;
  total: number;
  refno: string | null;
  refno2: string | null;
  refno3: string | null;
  refno4: string | null;
  refno5: string | null;
  refno6: string | null;
  paymentmode: string | null;
  createdon: string;
  updatedon: string | null;
  phone_no: string;
  email: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  transaction_on: string | null;
  thumbnail_url: string | null;
  invoice_url: string | null;
}

export interface OrderHistoryPagination {
  page: number;
  per_page: number;
  total_pages: number;
  total_items: number;
}

export interface OrderHistoryData {
  orderhistory: OrderHistoryItem[];
  pagination: OrderHistoryPagination;
}

export interface OrderHistoryResponse {
  message: string;
  data: OrderHistoryData;
  success: boolean;
}

export const createPayGCCPayment = async (payload: PayGCCRequestPayload): Promise<PayGCCResponse> => {
  try {
    console.log("=== PAY GCC API REQUEST ===");
    console.log("Endpoint: /payment/getpaygccurl");
    console.log("Request Payload:", JSON.stringify(payload, null, 2));
    console.log("======================================");
    
    const response = await axiosInstance.post<PayGCCResponse>("/payment/getpaygccurl", payload);
    
    console.log("=== PAY GCC RAW API RESPONSE ===");
    console.log("Status:", response.status);
    console.log("Status Text:", response.statusText);
    console.log("Headers:", response.headers);
    console.log("Response Data (Raw):", JSON.stringify(response.data, null, 2));
    console.log("===========================================");
    
    return response.data;
  } catch (error: any) {
    console.log("=== PAY GCC RAW API ERROR ===");
    console.log("Error Status:", error?.response?.status);
    console.log("Error Status Text:", error?.response?.statusText);
    console.log("Error Headers:", error?.response?.headers);
    console.log("Error Response Data (Raw):", JSON.stringify(error?.response?.data, null, 2));
    console.log("=========================================");
    throw error.response?.data || error.message;
  }
};

export const fetchOrderHistory = async (
  payload: OrderHistoryRequestPayload
): Promise<OrderHistoryResponse> => {
  try {
    console.log("=== ORDER HISTORY API REQUEST ===");
    console.log("Endpoint: /payment/listorderhistory");
    console.log("Request Payload:", JSON.stringify(payload, null, 2));
    console.log("======================================");
    
    const response = await axiosInstance.post<OrderHistoryResponse>(
      "/payment/listorderhistory",
      payload
    );
    
    console.log("=== ORDER HISTORY RAW API RESPONSE ===");
    console.log("Status:", response.status);
    console.log("Status Text:", response.statusText);
    console.log("Response Data (Raw):", JSON.stringify(response.data, null, 2));
    console.log("===========================================");
    
    return response.data;
  } catch (error: unknown) {
    console.error("=== ORDER HISTORY API ERROR ===");
    console.error("Error Status:", (error as any)?.response?.status);
    console.error("Error Status Text:", (error as any)?.response?.statusText);
    console.error("Error Response Data:", JSON.stringify((error as any)?.response?.data, null, 2));
    console.error("Error Message:", (error as any)?.message);
    console.error("=========================================");
    
    const errorData =
      (error as { response?: { data?: unknown } })?.response?.data ||
      (error as { message?: string })?.message ||
      "Something went wrong";
    throw errorData;
  }
};

